// 模型加载器
import { PrimitiveCollection, Model, NearFarScalar, Cartesian3, Transforms, HeadingPitchRoll, Math } from "cesium"

export default class ModelLayer {

    /**
     * 
     * @param {Object} options 参数
     * @param {String} [options.url] 默认模型url
     * @param {Boolean} [options.hasPick] 是否可点击 true 可点击  false 不可点击
     */
    constructor(options) {
        this.hasPick = options.hasPick
        this.defaultUrl = options.url
    }

    /**
     * 
     * @param {String | Number} id 
     * @param {Object} options 
     * @param {String} [options.url] 模型url
     * @param {Number} [options.scale] 模型大小
     * @param {Array<Number>} [options.distanceDisplayCondition]
     * @param {Number} [options.heading] 模型旋转角
     * @param {Number} [options.pitch] 模型俯仰角
     * @param {Number} [options.roll] 模型翻转角
     */
    add(id, geometry, options) {
        const heading = options.heading ? Math.toRadians(options.heading) : 0
        const pitch = options.pitch ? Math.toRadians(options.pitch) : 0
        const roll = options.roll ? Math.toRadians(options.roll) : 0
        const position = Cartesian3.fromDegrees(...geometry)
        const modelMatrix = Transforms.headingPitchRollToFixedFrame(position, new HeadingPitchRoll(heading, pitch, roll))
        const mOptions = {
            id: id,
            url: options.url,
            scale: options.scale ? options.scale : 1,
            modelMatrix: modelMatrix
        }
        if(options.distanceDisplayCondition) {
            delete mOptions['scale']
            mOptions.distanceDisplayCondition = new NearFarScalar(...options.distanceDisplayCondition)
        }
        let model = this.modelCollection.add(Model.fromGltf(mOptions))
        model.metadata = {heading, pitch, roll, position}
    }

    remove(id) {
        const size = this.modelCollection.length
        for(let i=0; i<size; i++) {
            let model = this.modelCollection.get(i)
            if(model.id === id) {
                this.modelCollection.remove(model)
                return
            }
        }
    }

    setPositionById(id, geometry) {
        const size = this.modelCollection.length
        for(let i=0; i<size; i++) {
            let model = this.modelCollection.get(i)
            if(model.id === id) {
                const position = Cartesian3.fromDegrees(...geometry)
                let {heading, pitch, roll} = model.metadata
                model.modelMatrix = Transforms.headingPitchRollToFixedFrame(position, new HeadingPitchRoll(heading, pitch, roll))
                return
            }
        }
    }

    /**
     * 
     * @param {Number | String} id 
     * @param {Object} options 
     * @param {Number} [options.heading] 模型旋转角
     * @param {Number} [options.pitch] 模型俯仰角
     * @param {Number} [options.roll] 模型翻转角
     */
    setHeadingPitchRoll(id, options) {
        const size = this.modelCollection.length
        for(let i=0; i<size; i++) {
            let model = this.modelCollection.get(i)
            if(model.id === id) {
                let {position} = model.metadata
                const heading = options.heading ? Math.toRadians(options.heading) : 0
                const pitch = options.pitch ? Math.toRadians(options.pitch) : 0
                const roll = options.roll ? Math.toRadians(options.roll) : 0
                model.modelMatrix = Transforms.headingPitchRollToFixedFrame(position, new HeadingPitchRoll(heading, pitch, roll))
                return
            }
        }
    }

    /**
     * 
     * @param {PrimitiveCollection} primitives 
     */
    addTo(primitives) {
        this.modelCollection = primitives.add(new PrimitiveCollection())
    }

    destroy() {
        this.modelCollection.destroy()
    }

    clear() {
        this.modelCollection.removeAll()
    }
}